class CodeError extends Error {
    constructor(message, code, error) {
        super(message);
        this.code = code;
        this.error = error;
    }
}
export default CodeError;
